import { FC } from 'react';

export const ArrowIcon: FC = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 17.5L17 7.5" stroke="#242424" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7 7.5H17V17.5" stroke="#242424" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
